import { ArchivedStatus } from 'components/domain/archived/ArchivedPicker/ArchivedPicker';

export const DEFAULT_TIMESHEETS_ARCHIVED_STATUS: ArchivedStatus = 'unarchived';
